module.exports = __webpack_public_path__ + "img/tab_customer-w.93443544.svg";